import { createTheme } from '@mui/material/styles';

// Tema monocromático estricto - Solo negro y blanco
const strictMonochromeTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { 
      main: '#FFFFFF',
      contrastText: '#000000'
    },
    secondary: { 
      main: '#FFFFFF',
      contrastText: '#000000'
    },
    background: { 
      default: '#000000', 
      paper: '#000000' 
    },
    text: { 
      primary: '#FFFFFF', 
      secondary: '#FFFFFF' 
    },
    divider: '#FFFFFF',
    error: { main: '#FFFFFF' },
    warning: { main: '#FFFFFF' },
    info: { main: '#FFFFFF' },
    success: { main: '#FFFFFF' }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          textTransform: 'uppercase',
          fontWeight: 600,
          color: '#FFFFFF',
          border: '1px solid #FFFFFF',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: '#FFFFFF',
            color: '#000000',
            border: '1px solid #FFFFFF'
          },
          '&:disabled': {
            color: '#FFFFFF',
            border: '1px solid #FFFFFF',
            opacity: 0.5
          }
        },
        contained: {
          backgroundColor: '#FFFFFF',
          color: '#000000',
          border: '1px solid #FFFFFF',
          '&:hover': {
            backgroundColor: '#000000',
            color: '#FFFFFF',
            border: '1px solid #FFFFFF'
          }
        },
        outlined: {
          borderColor: '#FFFFFF',
          color: '#FFFFFF',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: '#FFFFFF',
            color: '#000000',
            borderColor: '#FFFFFF'
          }
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          backgroundColor: '#000000',
          border: '1px solid #FFFFFF',
          color: '#FFFFFF'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          backgroundColor: '#000000',
          border: '1px solid #FFFFFF',
          color: '#FFFFFF'
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 0,
          backgroundColor: '#000000',
          border: '1px solid #FFFFFF',
          color: '#FFFFFF'
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#000000',
          borderBottom: '1px solid #FFFFFF',
          color: '#FFFFFF'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 0,
            backgroundColor: '#000000',
            '& fieldset': {
              borderColor: '#FFFFFF'
            },
            '&:hover fieldset': {
              borderColor: '#FFFFFF'
            },
            '&.Mui-focused fieldset': {
              borderColor: '#FFFFFF'
            },
            '& input': {
              color: '#FFFFFF'
            }
          },
          '& .MuiInputLabel-root': {
            color: '#FFFFFF'
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: '#FFFFFF'
          }
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: '#000000',
          color: '#FFFFFF',
          border: '1px solid #FFFFFF',
          borderRadius: 0
        }
      }
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          '& .MuiLinearProgress-bar': {
            backgroundColor: '#000000'
          }
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          color: '#FFFFFF',
          borderBottom: '1px solid #FFFFFF'
        },
        head: {
          backgroundColor: '#000000',
          color: '#FFFFFF',
          fontWeight: 600
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: '#FFFFFF',
          '&.Mui-selected': {
            color: '#FFFFFF'
          }
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: '#FFFFFF'
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: '#FFFFFF',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)'
          }
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          color: '#FFFFFF'
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          backgroundColor: '#000000',
          border: '1px solid #FFFFFF',
          color: '#FFFFFF',
          '& .MuiAlert-icon': {
            color: '#FFFFFF'
          }
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          color: '#FFFFFF'
        }
      }
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          color: '#FFFFFF',
          '&.Mui-checked': {
            color: '#FFFFFF'
          }
        },
        track: {
          backgroundColor: '#FFFFFF'
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          color: '#FFFFFF',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#FFFFFF'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#FFFFFF'
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#FFFFFF'
          }
        },
        icon: {
          color: '#FFFFFF'
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: '#FFFFFF',
          backgroundColor: '#000000',
          '&:hover': {
            backgroundColor: '#FFFFFF',
            color: '#000000'
          },
          '&.Mui-selected': {
            backgroundColor: '#FFFFFF',
            color: '#000000'
          }
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: '#000000',
          border: '1px solid #FFFFFF',
          borderRadius: 0
        }
      }
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: '#FFFFFF'
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: '#FFFFFF'
        }
      }
    }
  }
});

export default strictMonochromeTheme;